import {
    LuBox,
    LuCircleUserRound,
    LuWarehouse,
    LuTruck,
    LuWallet,
    LuUserCog,
} from "react-icons/lu";
import {
    ProductData,
    ProductCreate,
    ProductEdit,
    ProductDetail,
} from "@/pages/products";
import {
    ProductCategoryData,
    ProductCategoryCreate,
    ProductCategoryEdit,
} from "@/pages/products-category";
import {
    ProductSubCategoryData,
    ProductSubCategoryCreate,
    ProductSubCategoryEdit,
} from "@/pages/products-sub-category";
import {
    ProductUnitData,
    ProductUnitCreate,
    ProductUnitEdit,
} from "@/pages/products-unit";
import {
    MaterialFormulaData,
    MaterialFormulaCreate,
    MaterialFormulaEdit,
    MaterialFormulaDetail,
} from "@/pages/material-formulas";
import {
    CustomerData,
    CustomerCreate,
    CustomerDetail,
} from "@/pages/customers";
import {
    WarehouseData,
    WarehouseCreate,
    WarehouseEdit,
} from "@/pages/warehouse";
import {
    SupplierData,
    SupplierCreate,
    SupplierEdit,
    SupplierDetail,
} from "@/pages/suppliers";
import { StaffData, StaffCreate, StaffEdit, StaffDetail } from "@/pages/staff";
import { RoleData, RoleCreate, RoleDetail, RolePermissions } from "@/pages/role";
import { MasterCashData, MasterCashCreate } from "@/pages/master-cash";
import {
    TransactionCategoryData,
    TransactionCategoryCreate,
} from "@/pages/transaction-category";

export const masterRoutes = {
    title: "MASTER DATA",
    type: "section",
    items: [
        {
            path: "/products",
            title: "Produk",
            icon: <LuBox />,
            children: [
                // Products
                {
                    path: "/products",
                    title: "Daftar Produk",
                    permission: "material.view",
                    component: <ProductData />,
                },
                {
                    path: "/products/create",
                    title: "Tambah Produk",
                    component: <ProductCreate />,
                    permission: "material.create",
                    type: "hidden",
                },
                {
                    path: "/products/:id/detail",
                    title: "Detail Produk",
                    component: <ProductDetail />,
                    permission: "material.view",
                    type: "hidden",
                },
                {
                    path: "/products/:id/edit",
                    title: "Edit Produk",
                    component: <ProductEdit />,
                    permission: "material.edit",
                    type: "hidden",
                },
                // Categories
                {
                    path: "/products-category",
                    title: "Kategori Produk",
                    permission: "material-category.view",
                    component: <ProductCategoryData />,
                },
                {
                    path: "/products-category/create",
                    title: "Tambah Kategori",
                    component: <ProductCategoryCreate />,
                    permission: "material-category.create",
                    type: "hidden",
                },
                {
                    path: "/products-category/:id/edit",
                    title: "Edit Kategori",
                    component: <ProductCategoryEdit />,
                    permission: "material-category.edit",
                    type: "hidden",
                },
                // Sub Categories
                {
                    path: "/products-sub-category",
                    title: "Sub Kategori Produk",
                    permission: "material-category.view",
                    component: <ProductSubCategoryData />,
                },
                {
                    path: "/products-sub-category/create",
                    title: "Tambah Sub Kategori",
                    component: <ProductSubCategoryCreate />,
                    permission: "material-category.create",
                    type: "hidden",
                },
                {
                    path: "/products-sub-category/:id/edit",
                    title: "Edit Sub Kategori",
                    component: <ProductSubCategoryEdit />,
                    permission: "material-category.edit",
                    type: "hidden",
                },
                // Units
                {
                    path: "/products-unit",
                    title: "Satuan Produk",
                    permission: "material.view",
                    component: <ProductUnitData />,
                },
                {
                    path: "/products-unit/create",
                    title: "Tambah Satuan",
                    component: <ProductUnitCreate />,
                    permission: "material.create",
                    type: "hidden",
                },
                {
                    path: "/products-unit/:id/edit",
                    title: "Edit Satuan",
                    component: <ProductUnitEdit />,
                    permission: "material.edit",
                    type: "hidden",
                },
                // Formulas
                {
                    path: "/material-formulas/data",
                    title: "Formula Produksi",
                    permission: "material-formula.view",
                    component: <MaterialFormulaData />,
                },
                {
                    path: "/material-formulas/create",
                    title: "Tambah Formula",
                    component: <MaterialFormulaCreate />,
                    permission: "material-formula.create",
                    type: "hidden",
                },
                {
                    path: "/material-formulas/:id/detail",
                    title: "Detail Formula",
                    component: <MaterialFormulaDetail />,
                    permission: "material-formula.view",
                    type: "hidden",
                },
                {
                    path: "/material-formulas/:id/edit",
                    title: "Edit Formula",
                    component: <MaterialFormulaEdit />,
                    permission: "material-formula.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/finance",
            title: "Keuangan",
            icon: <LuWallet />,
            children: [
                {
                    path: "/master-cash/data",
                    title: "Master Cash",
                    permission: "master-cash.view",
                    component: <MasterCashData />,
                },
                {
                    path: "/master-cash/create",
                    title: "Tambah Master Cash",
                    component: <MasterCashCreate />,
                    permission: "master-cash.create",
                    type: "hidden",
                },
                {
                    path: "/master-cash/:id/edit",
                    title: "Edit Master Cash",
                    component: <MasterCashCreate />,
                    permission: "master-cash.edit",
                    type: "hidden",
                },
                {
                    path: "/transaction-category/data",
                    title: "Kategori Transaksi",
                    permission: "transaction-category.view",
                    component: <TransactionCategoryData />,
                },
                {
                    path: "/transaction-category/create",
                    title: "Tambah Kategori",
                    component: <TransactionCategoryCreate />,
                    permission: "transaction-category.create",
                    type: "hidden",
                },
                {
                    path: "/transaction-category/:id/edit",
                    title: "Edit Kategori",
                    component: <TransactionCategoryCreate />,
                    permission: "transaction-category.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/customers",
            title: "Pelanggan",
            icon: <LuCircleUserRound />,
            permission: "customer.view",
            children: [
                {
                    path: "/customers",
                    title: "Daftar Pelanggan",
                    component: <CustomerData />,
                },
                {
                    path: "/customers/create",
                    title: "Tambah Pelanggan",
                    component: <CustomerCreate />,
                    permission: "customer.create",
                    type: "hidden",
                },
                {
                    path: "/customers/:id/detail",
                    title: "Detail Pelanggan",
                    component: <CustomerDetail />,
                    permission: "customer.view",
                    type: "hidden",
                },
                {
                    path: "/customers/:id/edit",
                    title: "Edit Pelanggan",
                    component: <CustomerCreate />,
                    permission: "customer.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/warehouse",
            title: "Gudang",
            icon: <LuWarehouse />,
            permission: "warehouse.view",
            children: [
                {
                    path: "/warehouse",
                    title: "Daftar Gudang",
                    component: <WarehouseData />,
                },
                {
                    path: "/warehouse/create",
                    title: "Tambah Gudang",
                    component: <WarehouseCreate />,
                    permission: "warehouse.create",
                    type: "hidden",
                },
                {
                    path: "/warehouse/:id/edit",
                    title: "Edit Gudang",
                    component: <WarehouseEdit />,
                    permission: "warehouse.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/suppliers",
            title: "Supplier",
            icon: <LuTruck />,
            permission: "supplier.view",
            children: [
                {
                    path: "/suppliers",
                    title: "Daftar Supplier",
                    component: <SupplierData />,
                },
                {
                    path: "/suppliers/create",
                    title: "Tambah Supplier",
                    component: <SupplierCreate />,
                    permission: "supplier.create",
                    type: "hidden",
                },
                {
                    path: "/suppliers/:id/detail",
                    title: "Detail Supplier",
                    component: <SupplierDetail />,
                    permission: "supplier.view",
                    type: "hidden",
                },
                {
                    path: "/suppliers/:id/edit",
                    title: "Edit Supplier",
                    component: <SupplierEdit />,
                    permission: "supplier.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/hr",
            title: "HR",
            icon: <LuUserCog />,
            children: [
                {
                    path: "/staff",
                    title: "Staff",
                    permission: "staff.view",
                    component: <StaffData />,
                },
                {
                    path: "/staff/create",
                    title: "Tambah Staff",
                    component: <StaffCreate />,
                    permission: "staff.create",
                    type: "hidden",
                },
                {
                    path: "/staff/:id/edit",
                    title: "Edit Staff",
                    component: <StaffEdit />,
                    permission: "staff.edit",
                    type: "hidden",
                },
                {
                    path: "/staff/:id/detail",
                    title: "Detail Staff",
                    component: <StaffDetail />,
                    permission: "staff.view",
                    type: "hidden",
                },
                {
                    path: "/role",
                    title: "Hak Akses",
                    permission: "role.view",
                    component: <RoleData />,
                },
                {
                    path: "/role/create",
                    title: "Tambah Hak Akses",
                    component: <RoleCreate />,
                    permission: "role.create",
                    type: "hidden",
                },
                {
                    path: "/role/:id/detail",
                    title: "Detail Hak Akses",
                    component: <RoleDetail />,
                    permission: "role.view",
                    type: "hidden",
                },
                {
                    path: "/role/:id/edit",
                    title: "Edit Hak Akses",
                    component: <RoleCreate />,
                    permission: "role.edit",
                    type: "hidden",
                },
                {
                    path: "/role/:id/permissions",
                    title: "Kelola Permission",
                    component: <RolePermissions />,
                    permission: "role.edit",
                    type: "hidden",
                },
            ],
        },
    ],
};
